import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('configurations');

const state = {
  configurationSearchResults: [],
  currentConfiguration: {},
};

const getters = {
  configurationSearchResults: (state) => state.configurationSearchResults,
  currentConfiguration: (state) => state.currentConfiguration,
};

const mutations = {
  setConfigurationSearchResults: (state, configurationSearchResults) => {
    state.configurationSearchResults = configurationSearchResults;
  },
  updateConfigurationSearchResults: (state, task) => {
    const index = state.configurationSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.configurationSearchResults, index, task);
  },
  removeFromConfigurationSearchResults: (state, id)=>{
    state.configurationSearchResults.data = state.configurationSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.configurationSearchResults.total--;
  },
  setCurrentConfiguration: (state, currentConfiguration) => {
    state.currentConfiguration = currentConfiguration;
  },
};

const actions = {
  async searchConfigurations({commit}, query) {
    const response = await API.search(query);
    commit('setConfigurationSearchResults', response.data);
    return response.data;
  },
  async loadConfiguration({commit}, id) {
    const response = await API.load(id);
    commit('setCurrentConfiguration', response.data);
    return response.data;
  },
  async createConfiguration({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateConfiguration({commit}, payload) {
    const response = await API.update(payload.id, payload.data, payload.headers);
    commit('updateConfigurationSearchResults', response.data);
    return response.data;
  },
  async deleteConfiguration({commit}, payload) {
    const response = await API.remove(payload.id, payload.headers);
    commit('removeFromConfigurationSearchResults', payload.id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
